import KunLoading36 from './src/index'

KunLoading36.install = function (Vue) {
	Vue.component(KunLoading36.name, KunLoading36);
}

export default KunLoading36;
